export const FINCH_BASE_URL = 'https://tryfinch.com';
export const FINCH_DOCS_BASE_URL = 'https://developer.tryfinch.com';
